/* Property: Supports base64 or not */

define({
    icon: true,
    iconClass: true,
    quickAccessIcon: true

});